import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useAuthStore } from 'src/entities/user/store/useAuthStore';

import { Spinner } from 'src/shared/components/ui';

const HomePage = () => {
  const [searchParams] = useSearchParams();
  const authToken = useAuthStore((state) => state.authToken);
  const navigate = useNavigate();

  const authTokenQuery = searchParams.get('auth_token');

  useEffect(() => {
    setTimeout(() => {
      if (authToken) {
        navigate('/products', { replace: true });
      } else {
        navigate('/login', { replace: true });
      }
    }, 300);
  }, [authToken, authTokenQuery, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Spinner />
    </div>
  );
};

export default HomePage;
